var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"item"},[_c('div',[_c('p',{staticClass:"regular-14 mrg-bottom-0"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"regular-12"},[_vm._v(_vm._s(_vm.description))])]),_c('a-radio',{attrs:{"disabled":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }